import routes from '@routes';

import { CacheProps, fetchApi } from '../../fetch';

const getProvincesList = ({ ...rest }: CacheProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.locations.province-list'],
    payload: {
      country_id: 99,
      limit: 50,
    },
    withToken: true,
    ...rest,
  });
};

export default getProvincesList;
